import React from "react";
import styled from "styled-components";

import numOne from 'img/landingpage/list-num-1-book.png';
import numTwo from 'img/landingpage/list-num-2-book.png';
import numThree from 'img/landingpage/list-num-3-book.png';

const Wrap = styled.div`
    padding: 20px;
    background-color: #ff7a57;
`;

const Container = styled.div`
    max-width: 1000px;
    margin: 0 auto;

    display: flex;
    justify-content: center;
    align-items: center;

    color: #fff;

    @media screen and (max-width: 900px) {
        flex-direction: column;
    }
`;

const ListItem = styled.div`
    margin: 20px 10px;
    display: flex;
    max-width: 500px;
    align-items: center;
    flex-basis: 33%;
    flex-shrink: 0;
`;

const ListNum = styled.img`
    margin-right: 15px;
    width: 60px;
    height: 60px;
`;

const ListContent = styled.div`
    text-align: left;

    h3 {
        margin: 0 0 3px 0;
        font-size: 16px;
    }

    p {
        margin: 0;
        font-size: 15px;
        line-height: 1.4em;
    }
`;

const Steps = ({ text }) => {
    return (
        <Wrap>
            <Container>
                <ListItem>
                    <ListNum src={numOne} alt="Step 1" />
                    <ListContent>
                        <h3>{text.stepOneHeading}</h3>
                        <p>{text.stepOneText}</p>
                    </ListContent>
                </ListItem>
                <ListItem>
                    <ListNum src={numTwo} alt="Step 2" />
                    <ListContent>
                        <h3>{text.stepTwoHeading}</h3>
                        <p>{text.stepTwoText}</p>
                    </ListContent>
                </ListItem>
                <ListItem>
                    <ListNum src={numThree} alt="Step 3" />
                    <ListContent>
                        <h3>{text.stepThreeHeading}</h3>
                        <p>{text.stepThreeText}</p>
                    </ListContent>
                </ListItem> 
            </Container>
        </Wrap>
    )
};

export default Steps;
